"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCalendar = exports.Wrapper = void 0;
const app_1 = require("@obvio/app");
const react_calendar_1 = __importDefault(require("react-calendar"));
const utils_1 = require("../utils");
exports.Wrapper = (0, app_1.styled)(utils_1.InputWrapper) `
  input {
    cursor: pointer !important;
  }
  color: ${(theme) => theme.colors.gray};
`;
exports.StyledCalendar = (0, app_1.styled)(react_calendar_1.default) `
  width: 280px;
  color: ${(theme) => theme.colors.primary.deep};
  font-size: 0.8125rem;

  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    height: 40px;
    display: flex;
  }
  .react-calendar__navigation button {
    min-width: 40px;
    background: none;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__navigation button[disabled] {
    background-color: #f0f0f0;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers {
    font-weight: bold;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  }
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 40px);
    grid-auto-rows: 40px;
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__month-view__days > .react-calendar__tile {
    position: relative;
    height: 1.75rem;
    width: 1.75rem;
    padding: 0;
    margin: auto;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: ${(theme) => theme.colors.primary.alpha(0.1)};
  }
  .react-calendar__tile--now {
    background: ${(theme) => theme.colors.primary.alpha(0.1)};
  }
  .react-calendar__tile--hasActive {
    background: ${(theme) => theme.colors.secondary};
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: ${(theme) => theme.colors.secondary};
  }
  .react-calendar__tile--active {
    background: ${(theme) => theme.colors.primary};
    color: white;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: ${(theme) => theme.colors.secondary};
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: ${(theme) => theme.colors.gray.light};
  }

  abbr {
    text-decoration: none;
    position: relative;
    z-index: 1;
  }
`;
